var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 9V19C4 19.5523 4.44772 20 5 20H8M20 9V19C20 19.5523 19.5523 20 19 20H16", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M2 10L10.971 4.6174C11.6044 4.23738 12.3956 4.23738 13.029 4.61739L22 10", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M16 20C16 17.2386 14.2091 15 12 15C9.79086 15 8 17.2386 8 20", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "2.25", stroke: "#303030", strokeWidth: "1.5" })
  );
});